<div class="row">
  <div class="col-12">
    <form [formGroup]="powerUserRegistrationForm">
      <div class="row" class="row border Page-Header">
        <div class="col-12">
          <h6 class="HeadContent">Add Power User</h6>
        </div>
      </div>
      <!-- <div class="row pt-1">
  <div class="col-12">

    <div class="col-6">
      <div class="text-center" style="font-size: 20px;font-weight: 600;">Registration Form</div>
  </div>
  <div class="col-6">

  </div>
          </div>
        </div> -->
      <div class="row pt-1">
        <div class="col-12">
          <div class="row">
            <div
              class="col-6"
              [ngClass]="{
                'my-disable':
                  powerUserRegistrationForm.value.status == 'Disabled'
              }"
            >
              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0 label-red">*</div>
                    <div class="p-0">First Name</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <input
                    type="text"
                    class="form-control form-control-sm input-txt"
                    formControlName="firstName"
                    [ngClass]="{'input-invalid': powerUserRegistrationForm.get('firstName')?.touched && powerUserRegistrationForm.get('firstName')?.invalid}"
                    required
                  />
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0">Middle Name</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <input
                    type="text"
                    class="form-control form-control-sm input-txt"
                    formControlName="middleName"
                  />
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0 label-red">*</div>
                    <div class="p-0">Last Name</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <input
                    type="text"
                    class="form-control form-control-sm input-txt"
                    formControlName="lastName"
                    [ngClass]="{'input-invalid': powerUserRegistrationForm.get('lastName')?.touched && powerUserRegistrationForm.get('lastName')?.invalid}"

                    required
                  />
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0">Full Name</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <input
                    type="text"
                    class="form-control form-control-sm input-txt"
                    formControlName="fullName"
                  />
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0 label-red">*</div>
                    <div class="p-0">Email Address</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <input
                    type="email"
                    class="form-control form-control-sm input-txt"
                    formControlName="emailAddress"
                    [ngClass]="{'input-invalid': powerUserRegistrationForm.get('emailAddress')?.touched && powerUserRegistrationForm.get('emailAddress')?.invalid}"

                    required
                  />
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-12">
                  <div class="row">
                    <!-- Label Column -->
                    <div class="col-4 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0 label-red">*</div>
                        <div class="p-0">Primary Phone Number</div>
                      </div>
                    </div>

                    <!-- Input Column -->
                    <div class="col-8 pt-1 px-1">
                      <div
                        class="p-0 border"
                        style="padding-top: 4px; width: 100%; text-overflow: ellipsis; border-radius: 4px;"
                      >
                        <div class="d-flex" style="padding-bottom: 4px;">
                          <!-- Country Code -->
                          <div class="p-0 px-1 pt-1">
                            <select
                              class="form-control form-control-sm inputfield-txt"
                              [ngClass]="{ borderview1: countrynumber1flag == true }"
                              formControlName="countryCode1"
                              (ngModelChange)="selectcountrycode()"
                              required
                              [ngClass]="{'input-invalid': powerUserRegistrationForm.get('countryCode1')?.touched && powerUserRegistrationForm.get('countryCode1')?.invalid}"

                            >
                              <option selected value="" hidden>
                                Country Code*
                              </option>
                              <option
                                class="border-bottom"
                                *ngFor="let code of countryCode"
                                [value]="code.Code"
                              >
                                {{ code.Name }}
                              </option>
                            </select>
                          </div>

                          <!-- Phone Number Input + Error -->
                          <div class="p-0 px-1 pt-1">
                            <input
                              type="number"
                              [ngClass]="{ borderview1: phonenumber1flag == true }"
                              oninput="this.value=this.value.slice(0,this.maxLength)"
                              formControlName="primaryPhoneNumber"
                              (ngModelChange)="selectphonemnumber1()"
                              maxlength="10"
                              [ngClass]="{'input-invalid': powerUserRegistrationForm.get('primaryPhoneNumber')?.touched && powerUserRegistrationForm.get('primaryPhoneNumber')?.invalid}"
                              placeholder="Phone Number 1*"
                              class="form-control form-control-sm inputfield-txt1"
                            />

                          </div>
                          <!-- End Input+Error -->
                        </div>
                      </div>
                    </div>
                    <!-- End Input Column -->
                  </div>
                </div>
              </div>
              <!-- Error Message Block -->
              <div class="row pt-1">
                <div class="col-12">
                  <div class="row">
                    <!-- Label Column -->
                    <div class="col-4 text-right pt-1 pl-1 pr-0">

              </div>
              <div
              *ngIf="powerUserRegistrationForm.get('primaryPhoneNumber')?.touched && powerUserRegistrationForm.get('primaryPhoneNumber')?.invalid"
              class="text-danger small mt-1 col-8"
            >
              <div class="text-danger" *ngIf="powerUserRegistrationForm.get('primaryPhoneNumber')?.errors?.['required']">
                Phone number is required.
              </div>
              <div class="text-danger" *ngIf="powerUserRegistrationForm.get('primaryPhoneNumber')?.errors?.['pattern']">
                Please enter a valid 10-digit phone number.
              </div>
            </div>
              </div>
              </div>
              </div>
              <div class="row pt-1">
                <div class="col-12">
                  <div class="row">
                    <div class="col-4 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <!-- <div class="p-0 label-red">*</div>          -->
                        <div class="p-0">Secondary Phone Number</div>
                      </div>
                    </div>

                    <div class="col-8 pt-1 px-1">
                      <div
                        class="p-0 border"
                        style="
                          padding-top: 4px;
                          width: 100%;
                          text-overflow: ellipsis;
                          border-radius: 4px;
                          height: 45px;
                        "
                      >
                        <div class="d-flex">
                          <div class="p-0 px-1 pt-1">
                            <select
                              class="form-control form-control-sm inputfield-txt"
                              [ngClass]="{
                                borderview1: countrynumber2flag == true
                              }"
                              formControlName="countryCode2"
                              (ngModelChange)="selectcountrycode1()"
                            >
                              <option selected value="" hidden>
                                Country Code
                              </option>
                              <option
                                class="border-bottom"
                                *ngFor="let code of countryCode"
                                [value]="code.Code"
                              >
                                {{ code.Name }}
                              </option>
                            </select>
                          </div>
                          <div class="p-0 px-1 pt-1">
                            <input
                              type="number"
                              [ngClass]="{
                                borderview1: phonenumber2flag == true
                              }"
                              oninput="this.value=this.value.slice(0,this.maxLength)"
                              formControlName="secondaryPhoneNumber"
                              (ngModelChange)="selectphonemnumber2()"
                              maxlength="10"
                              placeholder="Phone Number 2"
                              class="form-control form-control-sm inputfield-txt1"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0 label-red">*</div>
                    <div class="p-0">Primary Language</div>
                  </div>
                  <div class="d-flex flex-row-reverse">
                    <small class="p-0">(Mother Tongue)</small>
                  </div>
                </div>
                <div class="col-8 pt-2 px-1">
                  <select
                    class="form-control form-control-sm input-txt"
                    formControlName="PrimaryLanguage"
                    [ngClass]="{'input-invalid': powerUserRegistrationForm.get('PrimaryLanguage')?.touched && powerUserRegistrationForm.get('PrimaryLanguage')?.invalid}"

                  >
                    <option
                      class="border-bottom"
                      *ngFor="let lan of LanguageType"
                      value="{{ lan.Code }}"
                    >
                      {{ lan.Name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0 label-red">*</div>
                    <div class="p-0">Education Qualifications</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <select
                    class="form-control form-control-sm input-txt"
                    formControlName="educationQualification"
                    [ngClass]="{'input-invalid': powerUserRegistrationForm.get('educationQualification')?.touched && powerUserRegistrationForm.get('educationQualification')?.invalid}"

                  >
                    <option
                      class="border-bottom"
                      *ngFor="let eq of educationalQualifications"
                      value="{{ eq.Code }}"
                    >
                      {{ eq.Name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <div class="p-0 label-red">*</div>
                    <div class="p-0">Select Years of Experience</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <select
                    class="form-control form-control-sm input-txt"
                    formControlName="Experience"
                    [ngClass]="{'input-invalid': powerUserRegistrationForm.get('Experience')?.touched && powerUserRegistrationForm.get('Experience')?.invalid}"
                  >
                    <option
                      class="border-bottom"
                      *ngFor="let experience of experienceType"
                      value="{{ experience.Code }}"
                    >
                      {{ experience.Name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row pt-1">
                <div class="col-4 text-right pt-1 pl-1 pr-0">
                  <div class="d-flex flex-row-reverse">
                    <!-- <div class="p-0 label-red">*</div>          -->
                    <div class="p-0">Experience Description</div>
                  </div>
                </div>
                <div class="col-8 pt-1 px-1">
                  <textarea
                    maxlength="4000"
                    formControlName="Comment_Text"
                    class="form-control input-txt1"
                  ></textarea>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="row pt-3">
                    <div class="col-4"></div>
                    <div class="col-8">
                      <div class="d-flex">
                        <div class="px-1">
                          <button
                          type="submit"
                          class="btn btn-sm bl-btn"
                          [disabled]="isSaveDisabled()"
                          (click)="saveOnClick()"
                        >
                          Save
                        </button>
                        </div>
                        <div class="px-1">
                          <button
                            type="button"
                            class="btn btn-sm bg-light border"
                            (click)="Cancelbutton()"
                          >
                            Cancel
                          </button>
                        </div>
                        <!-- <div class="px-1">
                          <button
                            type="button"
                            class="btn btn-sm bg-light border"
                          >
                            Resend Password/Activation Link
                          </button>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-6"
              [ngClass]="{
                'my-disable':
                  powerUserRegistrationForm.value.status == 'Disabled'
              }"
            >
              <div class="row">
                <div class="col-12">
                  <div class="row pt-2">
                    <div class="col-3 text-right pr-0 pt-1 pl-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0 label-red">*</div>
                        <div class="p-0">Status</div>
                      </div>
                    </div>
                    <div class="col-3 px-1">
                      <input
                        type="text"
                        [attr.disabled]="true"
                        class="form-control form-control-sm input-txt-status"
                        formControlName="status"
                        [ngClass]="{'input-invalid': powerUserRegistrationForm.get('status')?.touched && powerUserRegistrationForm.get('status')?.invalid}"
                      />
                    </div>
                    <div class="col-5">
                      <div class="row">
                        <div class="col-12">
                          <div class="d-flex">
                            <!-- <div class="px-1">
                              <button
                                type="button"
                                class="btn btn-sm bg-light border"
                              >
                                Change Status
                              </button>
                            </div> -->
                            <div class="px-1">
                              <button
                                type="button"
                                class="btn btn-sm bl-btn"
                                (click)="onClickAssignRoleButton()"
                              >
                                Assign Role
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row pt-1">
                    <div class="col-3 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0 label-red">*</div>
                        <div class="p-0">Address Line 1</div>
                      </div>
                    </div>
                    <div class="col-7 pt-1 px-1">
                      <input
                        type="text"
                        class="form-control form-control-sm input-txt"
                        formControlName="addressLine1"
                        [ngClass]="{'input-invalid': powerUserRegistrationForm.get('addressLine1')?.touched && powerUserRegistrationForm.get('addressLine1')?.invalid}"
                        required
                      />
                    </div>
                  </div>

                  <div class="row pt-1">
                    <div class="col-3 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <!-- <div class="p-0 label-red">*</div>          -->
                        <div class="p-0">Address Line 2</div>
                      </div>
                    </div>
                    <div class="col-7 pt-1 px-1">
                      <input
                        type="text"
                        class="form-control form-control-sm input-txt"
                        formControlName="addressLine2"
                      />
                    </div>
                  </div>

                  <div class="row pt-1">
                    <div class="col-3 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0">Address Line 3</div>
                      </div>
                    </div>
                    <div class="col-7 pt-1 px-1">
                      <input
                        type="text"
                        class="form-control form-control-sm input-txt"
                        formControlName="PostOffice"
                      />
                    </div>
                  </div>

                  <div class="row pt-1">
                    <div class="col-3 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0 label-red">*</div>
                        <div class="p-0">City</div>
                      </div>
                    </div>
                    <div class="col-7 pt-1 px-1">
                      <input
                        type="text"
                        class="form-control form-control-sm input-txt"
                        formControlName="City"
                        required
                        [ngClass]="{'input-invalid': powerUserRegistrationForm.get('City')?.touched && powerUserRegistrationForm.get('City')?.invalid}"
                      />
                    </div>
                  </div>

                  <div class="row pt-1">
                    <div class="col-3 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0 label-red">*</div>
                        <div class="p-0">PIN Code</div>
                      </div>
                    </div>
                    <div class="col-7 pt-1 px-1">
                      <input
                        type="text"
                        class="form-control form-control-sm input-txt"
                        formControlName="PINcode"
                        [ngClass]="{'input-invalid': powerUserRegistrationForm.get('PINcode')?.touched && powerUserRegistrationForm.get('PINcode')?.invalid}"
                        required
                      />
                    </div>
                  </div>

                  <div class="row pt-1">
                    <div class="col-3 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0 label-red">*</div>
                        <div class="p-0">Country</div>
                      </div>
                    </div>
                    <div class="col-7 pt-1 px-1">
                      <select
                        class="form-control form-control-sm input-txt"
                        (change)="onCountryChange($event)"
                        [ngClass]="{'input-invalid': powerUserRegistrationForm.get('Country')?.touched && powerUserRegistrationForm.get('Country')?.invalid}"
                        formControlName="Country"
                      >

                        <option
                          class="border-bottom"
                          *ngFor="let country of countryName"
                          value="{{ country.Code }}"
                        >
                          {{ country.Name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row pt-1">
                    <div class="col-3 text-right pt-1 pl-1 pr-0">
                      <div class="d-flex flex-row-reverse">
                        <div class="p-0 label-red">*</div>
                        <div class="p-0">State</div>
                      </div>
                    </div>
                    <div class="col-7 pt-1 px-1">
                      <select
                        class="form-control form-control-sm input-txt"
                        formControlName="State"
                        [ngClass]="{'input-invalid': powerUserRegistrationForm.get('State')?.touched && powerUserRegistrationForm.get('State')?.invalid}"
                      >
                      <option value= null>

                      </option>
                        <option
                          class="border-bottom"
                          *ngFor="let state of State"
                          value="{{ state.Code }}"
                        >
                          {{ state.Name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


    </form>
  </div>
</div>

<div class="modal fade show Model_popup1" *ngIf="Assignroletouser">
  <div class="modal-dialog modal-dialog-centered modal-dialog-StudyMaterial">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Assign Roles to Power User
        </h6>
        <button
          type="button"
          class="close"
          (click)="onClickAssignRoleButton()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-assign-roles-to-power-user
          (Closepopup)="Closepopup($event)"
        ></app-assign-roles-to-power-user>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade show modal-dialog-centered"
  style="padding-right: 4px; display: block; background-color: #00000075"
  *ngIf="cancelalertflag"
>
  <div class="modal-dialog modal-dialog-alert1 modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
        <button
          type="button"
          class="close"
          style="padding-right: 20px; font-size: 30px; outline: 0"
          (click)="AlertCancelpopup()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Do you want to Discard or Continue Editing ?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button
                  type="button"
                  class="btn btn-sm bg-light border"
                  (click)="DiscardChanges()"
                >
                  Discard Changes
                </button>
              </div>
              <div class="px-1">
                <button
                  type="button"
                  class="btn btn-sm bl-btn"
                  (click)="AlertCancelpopup()"
                >
                  Continue Editing
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
